import { render, staticRenderFns } from "./GestioneAttivitaAttivitaEditComponent.vue?vue&type=template&id=70dc684f"
import script from "./GestioneAttivitaAttivitaEditComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaAttivitaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports